export default "__VITE_ASSET__931fa8ee__"